import { useEffect } from "react";

const SITE_TITLE = "Hyvo: launch it in a parallel world first";

/** The browser tab says which page this is; leaving the page puts the site's title back. */
export function useTitle(title: string | null): void {
  useEffect(() => {
    if (!title) return;
    document.title = `${title} · Hyvo`;
    return () => {
      document.title = SITE_TITLE;
    };
  }, [title]);
}
